import Router from '@/router';
import { queryCategory, queryCategoryVideos, queryVideoByCategoryId } from '@/api/modules/ringQuery';
// 工具函数：处理视频项数据
const processVideoItem = (item) => {
    return {
        ...item,
        homePosterSrc: item.homePosterSrc || item.posterSrc,
        videoSrc: item.videoSrc.replace('http:', 'https:')
    };
};
// 工具函数：处理分类数据
const processCategoryItem = (item) => {
    return {
        ...item,
        subElementArray: item.subElementArray.map(processVideoItem)
    };
};
const categories = {
    namespaced: true,
    state: () => {
        let categorys = [];
        try {
            const storedCategorys = window.sessionStorage.getItem('categorys');
            if (storedCategorys) {
                categorys = JSON.parse(storedCategorys);
            }
        }
        catch (error) {
            console.error('Failed to parse categorys from sessionStorage:', error);
        }
        let categoryIdIndex = 0;
        try {
            const storedIndex = window.localStorage.getItem('categoryIdIndex');
            if (storedIndex) {
                categoryIdIndex = Number(storedIndex);
            }
        }
        catch (error) {
            console.error('Failed to parse categoryIdIndex from localStorage:', error);
        }
        return {
            categorys,
            categoryPageData: {},
            categoryIdIndex
        };
    },
    mutations: {
        // 更新栏目分类
        SET_CATEGORYS(state, categorys) {
            // 直接赋值新数组，而不是使用splice和push
            state.categorys = [...categorys];
            // 保存到sessionStorage
            try {
                window.sessionStorage.setItem('categorys', JSON.stringify(categorys));
            }
            catch (error) {
                console.error('Failed to save categorys to sessionStorage:', error);
            }
        },
        // 设置分类分页参数
        SET_CATEGORYS_PAGE_DATA(state, pageDatas) {
            state.categoryPageData = pageDatas;
        },
        // 更新分类页面数据
        UPDATE_PAGE_BY_CATEGORY_ID(state, data) {
            const { categoryId, pageNum, pageSize, isEmpty } = data;
            if (!state.categoryPageData[categoryId]) {
                state.categoryPageData[categoryId] = {
                    pageNum: 1,
                    pageSize: 20,
                    isEmpty: false
                };
            }
            if (pageNum !== undefined) {
                state.categoryPageData[categoryId].pageNum = pageNum;
            }
            if (pageSize !== undefined) {
                state.categoryPageData[categoryId].pageSize = pageSize;
            }
            if (isEmpty !== undefined) {
                state.categoryPageData[categoryId].isEmpty = isEmpty;
            }
        },
        // 追加分类数据（避免重复）
        APPEND_CATEGORYS_ITEM(state, data) {
            const { id, list } = data;
            const categoryIndex = state.categorys.findIndex((item) => item.categoryId === id);
            if (categoryIndex === -1)
                return;
            const subElementArray = state.categorys[categoryIndex].subElementArray;
            const existingIds = new Set(subElementArray.map(item => item.id));
            // 只添加不存在的项
            const newItems = list.filter(item => !existingIds.has(item.id));
            subElementArray.push(...newItems);
        },
        // 设置分类项
        SET_CATEGORYS_ITEM(state, data) {
            const { id, list } = data;
            const categoryIndex = state.categorys.findIndex((item) => item.categoryId === id);
            if (categoryIndex !== -1) {
                state.categorys[categoryIndex].subElementArray.push(...list);
            }
        },
        // 设置分类ID索引
        SET_CATEGORYS_ID_INDEX(state, categoryIdIndex) {
            state.categoryIdIndex = categoryIdIndex === -1 ? 0 : categoryIdIndex;
            // 保存到localStorage
            try {
                window.localStorage.setItem('categoryIdIndex', String(state.categoryIdIndex));
            }
            catch (error) {
                console.error('Failed to save categoryIdIndex to localStorage:', error);
            }
        },
        // 在列表前添加数据（下拉刷新）
        UNSHIFT_RANDOM_LIST_TO_CATEGORYS(state, data) {
            const { id, list } = data;
            const categoryIndex = state.categorys.findIndex((item) => item.categoryId === id);
            if (categoryIndex === -1)
                return;
            const subElementArray = state.categorys[categoryIndex].subElementArray;
            const existingIds = new Set(subElementArray.map(item => item.id));
            // 只添加不存在的项
            const newItems = list.filter(item => !existingIds.has(item.id));
            subElementArray.unshift(...newItems);
        }
    },
    actions: {
        /**
         * 获取分类栏目总数据
         * @param context - Vuex action上下文
         * @param payload - 请求参数
         * @returns Promise 包含API响应
         */
        getCategorysList({ commit, rootState }, payload) {
            return new Promise((resolve, reject) => {
                queryCategoryVideos({
                    ...payload,
                    phone: rootState.ringtone?.phone,
                    pcid: Router.currentRoute.query.pcid
                })
                    .then((res) => {
                    if (res.code === '0000' && res.data) {
                        // 使用工具函数处理数据
                        const processedData = res.data.map(processCategoryItem);
                        commit('SET_CATEGORYS', processedData);
                    }
                    resolve(res);
                })
                    .catch((err) => {
                    console.error('Failed to get categories list:', err);
                    reject(err);
                });
            });
        },
        /**
         * 获取分类和第一个热门分类
         * @param context - Vuex action上下文
         * @param payload - 请求参数
         * @returns Promise 包含API响应
         */
        getCategory({ commit, rootState }, payload) {
            const { pageSize } = payload;
            const defaultPageSize = pageSize || 40;
            return new Promise((resolve, reject) => {
                queryCategory({
                    ...payload,
                    phone: rootState.ringtone?.phone,
                    pcid: Router.currentRoute.query.pcid
                })
                    .then((res) => {
                    if (res.code === '0000' && res.data) {
                        // 创建页面数据对象
                        const pageData = {};
                        // 处理分类数据
                        const processedData = res.data.map(item => {
                            const processedItem = processCategoryItem(item);
                            // 设置分页数据
                            pageData[item.categoryId] = {
                                pageNum: 1,
                                pageSize: defaultPageSize,
                                isEmpty: false
                            };
                            return processedItem;
                        });
                        commit('SET_CATEGORYS_PAGE_DATA', pageData);
                        commit('SET_CATEGORYS', processedData);
                        resolve(res);
                    }
                    else {
                        reject(new Error(res.message || '获取分类数据失败'));
                    }
                })
                    .catch((err) => {
                    console.error('Failed to get category:', err);
                    reject(err);
                });
            });
        },
        /**
         * 根据分类ID获取视频
         * @param context - Vuex action上下文
         * @param payload - 请求参数
         * @returns Promise 包含API响应
         */
        getVideosByCategoryId({ commit, state, rootState }, payload) {
            const { loadMore, pageSize, categoryId, pageNum } = payload;
            if (!categoryId) {
                return Promise.reject(new Error('缺少必要参数: categoryId'));
            }
            // 确保categoryPageData中有该分类的数据
            if (!state.categoryPageData[categoryId]) {
                commit('UPDATE_PAGE_BY_CATEGORY_ID', {
                    categoryId,
                    pageNum: 1,
                    pageSize: pageSize || 20,
                    isEmpty: false
                });
            }
            // 构建请求参数
            const pageData = {
                pageSize: pageSize || 20,
                categoryId,
                pageNum: pageNum || 1
            };
            // 处理加载更多的情况
            if (loadMore && state.categoryPageData[categoryId]) {
                pageData.pageNum = state.categoryPageData[categoryId].pageNum + 1;
                pageData.pageSize = state.categoryPageData[categoryId].pageSize;
            }
            return new Promise((resolve, reject) => {
                queryVideoByCategoryId({
                    ...pageData,
                    phone: rootState.ringtone?.phone,
                    pcid: Router.currentRoute.query.pcid
                })
                    .then((res) => {
                    if (res.code === '0000') {
                        if (res.data && res.data.colums) {
                            // 处理视频数据
                            const processedData = res.data.colums.map(processVideoItem);
                            if (processedData.length > 0) {
                                if (loadMore) {
                                    // 加载更多：更新页码并追加数据
                                    commit('UPDATE_PAGE_BY_CATEGORY_ID', {
                                        categoryId,
                                        pageNum: pageData.pageNum
                                    });
                                    commit('APPEND_CATEGORYS_ITEM', {
                                        id: categoryId,
                                        list: processedData
                                    });
                                }
                                else {
                                    // 首次加载：设置数据
                                    commit('SET_CATEGORYS_ITEM', {
                                        id: categoryId,
                                        list: processedData
                                    });
                                }
                                // 检查是否已加载完所有数据
                                const isLastPage = processedData.length < pageData.pageSize;
                                if (isLastPage) {
                                    commit('UPDATE_PAGE_BY_CATEGORY_ID', {
                                        categoryId,
                                        isEmpty: true
                                    });
                                    res.isEmpty = true;
                                }
                            }
                            else {
                                // 没有数据
                                commit('UPDATE_PAGE_BY_CATEGORY_ID', {
                                    categoryId,
                                    isEmpty: true
                                });
                                res.isEmpty = true;
                            }
                        }
                    }
                    resolve(res);
                })
                    .catch((err) => {
                    console.error(`Failed to get videos for category ${categoryId}:`, err);
                    reject(err);
                });
            });
        }
    }
};
export default categories;
